import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * Top-level error boundary. Prevents a single render error from painting the
 * React runtime error overlay across the whole app.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
        <div
          data-testid="app-error-boundary"
          className="max-w-md w-full bg-white border border-red-200 rounded p-6"
        >
          <div className="flex items-center gap-2 text-red-700">
            <AlertTriangle size={20} />
            <h2 className="font-black text-lg">Something went wrong</h2>
          </div>
          <p className="text-slate-600 text-sm mt-2">
            The page hit an unexpected error. Reload to continue.
          </p>
          <button
            data-testid="app-error-reload"
            onClick={this.handleReload}
            className="mt-4 inline-flex items-center gap-2 rounded bg-blue-700 hover:bg-blue-800 text-white h-10 px-4 text-sm font-semibold"
          >
            <RefreshCw size={14} /> Reload
          </button>
        </div>
      </div>
    );
  }
}
